module.exports = __webpack_public_path__ + "static/index/img/baikal-600.046e179a.jpg";